<template>
  <div>
    <div ref="hcaptchaContainer" />
  </div>
</template>
  
  <script>
  export default {
    name: 'CustomHcaptcha',
    props: {
      sitekey: {
        type: String,
        required: true
      }
    },
    emits: ['verified', 'expired', 'error'],
    mounted() {
      this.loadCaptchaScript()
        .then(() => {
          this.renderCaptcha();
        })
        .catch(error => {
          console.error('Failed to load hCaptcha script:', error);
        });
    },
    methods: {
      loadCaptchaScript() {
        return new Promise((resolve, reject) => {
          if (typeof window.hcaptcha !== 'undefined') {
            resolve();
          } else {
            const script = document.createElement('script');
            script.src = 'https://hcaptcha.com/1/api.js?render=explicit&onload=onHcaptchaLoad';
            script.async = true;
            script.defer = true;
  
            window.onHcaptchaLoad = () => {
              resolve();
            };
  
            script.onerror = () => {
              reject(new Error('hCaptcha script failed to load.'));
            };
  
            document.head.appendChild(script);
          }
        });
      },
      renderCaptcha() {
        window.hcaptcha.render(this.$refs.hcaptchaContainer, {
          sitekey: this.sitekey,
          callback: this.onVerify,
          'expired-callback': this.onExpired,
          'error-callback': this.onError,
          size: 'normal'
        });
      },
      onVerify(token) {
        this.$emit('verified', token);
      },
      onExpired() {
        this.$emit('expired');
      },
      onError(err) {
        this.$emit('error', err);
      }
    }
  };
  </script>
  
  <style scoped>
  /* 根据需要添加样式 */
  </style>
  